export default "__VITE_ASSET__B9XpYT_S__"